__turbopack_context__.v({
  "actions": "djCqOG_actions",
  "button": "djCqOG_button",
  "closeButton": "djCqOG_closeButton",
  "closeIcon": "djCqOG_closeIcon",
  "content": "djCqOG_content",
  "darkButton": "djCqOG_darkButton",
  "paper": "djCqOG_paper",
  "title": "djCqOG_title",
  "titlePhone": "djCqOG_titlePhone",
  "warningIcon": "djCqOG_warningIcon",
});
